module.exports = __webpack_public_path__ + "img/fish4.09360d48.png";